import api from '@/api'

const JourneyView = 'Journey';

export default (to, from, next) => {
    if (to.name === JourneyView) {
        api.journey.journeyViewed(to.params.journeyId)
    }
    next()
}
